import Footer from "../components/Footer";
import Navbar from "../components/navigation/Navbar";
import About from "../sections/About";
import Explore from "../sections/Explore";
import HandCraft from "../sections/HandCraft";
import Hero from "../sections/Hero";
import PersianArchitecture from "../sections/PersianArchitecture";
import PersianGulfAbout from "../sections/PersianGulfAbout";
import Village from "../sections/Village";
const Page = () => {
  return (
    <div
      className={` dark:bg-Darkscreen bg-lightscreen text-Darktext dark:text-white  overflow-hidden fa`}
    >
      <Navbar />
      <Hero />
      <div className="relative">
        <About />
        <div className="gradient-03 z-0" />
        <Explore />
      </div>
      <Village />
      <div className="relative">
        <div className="gradient-04 z-0" />
        <PersianGulfAbout />
      </div>
      <div className="relative">
        <div className="gradient-03 z-0" />
        <PersianArchitecture />
      </div>
      <div className="relative">
        <div className="gradient-04 z-0" />
        <HandCraft />
      </div>
      <Footer />
    </div>
  );
};

export default Page;
